const KEY = 'showAllBuildingsAutocomplete';
const COMPLIANCE_KEY = 'compliance_showAllBuildingsAutocomplete';

export const saveShowAllBuildingsFieldToStorage = (value: boolean) => {
  localStorage.setItem(KEY, value.toString());
}

export const loadShowAllBuildingsFieldFromStorage = (): string | null => {
  return localStorage.getItem(KEY);
}

export const removeShowAllBuildingsFieldFromStorage = () => {
  localStorage.removeItem(KEY)
}


export const saveComplianceShowAllBuildingsFieldToStorage = (value: boolean) => {
  localStorage.setItem(COMPLIANCE_KEY, value.toString());
}

export const loadComplianceShowAllBuildingsFieldFromStorage = () => {
  return localStorage.getItem(COMPLIANCE_KEY)
}

export const removeComplianceShowAllBuildingsFieldFromStorage = () => {
  localStorage.removeItem(COMPLIANCE_KEY)
}
